import { Environment } from './environment.model';

export const environment: Environment = {
  production: false,
  apiUrl: 'https://test-giif.mf.gov.pl',
  downloadFile: 'https://test-giif.mf.gov.pl',
  goAmlUrl: 'https://test-giif.mf.gov.pl/goaml-test/',
  authUrl: 'https://test-giif.mf.gov.pl',
  redirectUrl: 'https://test-giif.mf.gov.pl/waiting-page',
  redirectLogout: 'https://test-giif.mf.gov.pl',
  label: 'UAT',
};
